import { useEffect, useRef } from 'react';

export const usePrevious = (value) => {
  const reference = useRef();
  useEffect(() => {
    reference.current = value;
  });
  return reference.current;
};
